<template>
  <aside class="side-menu">
    <v-navigation-drawer v-model="globalState.drawer" app v-model:mini-variant="globalState.miniVariant"
      :width="globalState.miniVariant ? 56 : 256" class="gradient-drawer" elevation="0" color="transparent">
      <v-list>
        <v-list-item class="d-flex justify-end pa-0">
          <v-btn icon @click="toggleMiniVariant" class="btn-toggle">
            <v-icon size="24">mdi-menu</v-icon>
          </v-btn>
        </v-list-item>

        <v-divider />

        <v-list-item v-for="item in menuItems" :key="item.text" @click="navigate(item)">
          <template #prepend>
            <v-tooltip bottom v-if="globalState.miniVariant">
              <template #activator="{ props }">
                <span v-bind="props">
                  <v-icon size="24">{{ item.icon }}</v-icon>
                </span>
              </template>
              <span>{{ item.text }}</span>
            </v-tooltip>
            <v-icon v-else size="24">{{ item.icon }}</v-icon>
          </template>

          <v-list-item-title v-if="!globalState.miniVariant">
            &nbsp;&nbsp;{{ item.text }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </aside>
</template>

<script setup>
  import { inject } from 'vue';
  import { useRouter } from 'vue-router';

  const globalState = inject('globalState');
  const router = useRouter();

  const menuItems = [
    { text: 'Home', route: 'Lista Equipamentos', icon: 'mdi-home' },
    { text: 'Cad. Usuários', route: '', icon: 'mdi-account-group' },
    {
      text: 'Trends',
      icon: 'mdi-chart-line',
      external: true,
      url: 'https://g-4c69ebd0b7.grafana-workspace.us-east-2.amazonaws.com/goto/mV_CjybHz?orgId=1',
    },
    { text: 'Cad. Dispositivos', route: '', icon: 'mdi-devices' },
    { text: 'Cad. Equipamentos', route: '', icon: 'mdi-tools' },
    { text: 'Cad. Planta', route: '', icon: 'mdi-pine-tree' },
    { text: 'Alarmes', route: '', icon: 'mdi-bell-alert' },
    { text: 'Configurações', route: '', icon: 'mdi-cog' },
  ];

  function navigate(item) {
    if (item.external && item.url) {
      window.open(item.url, '_blank');
    } else if (item.route) {
      router.push({ name: item.route });
    }
  }

  function toggleMiniVariant() {
  }
</script>

<style>
.btn-toggle {
  background-color: transparent !important;
  box-shadow: none !important;
}

.btn-toggle:hover {
  background-color: rgba(0, 0, 0, 0.05) !important;
}

.gradient-drawer {
  background: var(--drawer-gradient) !important;
  border-right: none !important;
}
</style>